import { render, staticRenderFns } from "./DetailSpecificationButtons.vue?vue&type=template&id=a5f99670&scoped=true"
import script from "./DetailSpecificationButtons.vue?vue&type=script&lang=js"
export * from "./DetailSpecificationButtons.vue?vue&type=script&lang=js"
import style0 from "./DetailSpecificationButtons.vue?vue&type=style&index=0&id=a5f99670&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f99670",
  null
  
)

export default component.exports